import React from 'react';
import { BookOpen, GraduationCap, Moon, Settings, Sun } from 'lucide-react';
import { SettingsModal } from './SettingsModal';

interface HeaderProps {
  isDarkMode: boolean;
  onThemeToggle: () => void;
  apiKey: string;
  onApiKeyChange: (key: string) => void;
}

export function Header({ isDarkMode, onThemeToggle, apiKey, onApiKeyChange }: HeaderProps) {
  const [isSettingsOpen, setIsSettingsOpen] = React.useState(false);
  return (
    <header className="bg-white dark:bg-gray-800 border-b border-indigo-100 dark:border-gray-700 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="bg-indigo-600 dark:bg-indigo-500 p-2 rounded-lg">
              <BookOpen className="h-6 w-6 text-white" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                EduTube Search
              </h1>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                Curated Educational Content
              </p>
            </div>
          </div>
          
          <div className="flex items-center gap-4">
            <button
              onClick={() => setIsSettingsOpen(true)}
              className="p-2 text-gray-500 hover:text-gray-700 dark:text-gray-400 
                dark:hover:text-gray-200 transition-colors rounded-lg hover:bg-gray-100 
                dark:hover:bg-gray-700"
              aria-label="Open settings"
            >
              <Settings className="h-5 w-5" />
            </button>
            <button
              onClick={onThemeToggle}
              className="p-2 text-gray-500 hover:text-gray-700 dark:text-gray-400 
                dark:hover:text-gray-200 transition-colors rounded-lg hover:bg-gray-100 
                dark:hover:bg-gray-700"
              aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
            >
              {isDarkMode ? (
                <Sun className="h-5 w-5" />
              ) : (
                <Moon className="h-5 w-5" />
              )}
            </button>
            <GraduationCap className="h-8 w-8 text-indigo-600 dark:text-indigo-400" />
          </div>
        </div>
      </div>

      <SettingsModal
        isOpen={isSettingsOpen}
        onClose={() => setIsSettingsOpen(false)}
        apiKey={apiKey}
        onApiKeyChange={onApiKeyChange}
      />
    </header>
  );
}
